function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSharePpt = function SvgSharePpt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 56 56",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.985 0H7.963C7.155 0 6.5.655 6.5 1.926V55c0 .345.655 1 1.463 1h40.074c.808 0 1.463-.655 1.463-1V12.978c0-.696-.093-.92-.257-1.085L37.607.257A.884.884 0 0 0 36.985 0Z",
    style: {
      fill: "#e9e9e0",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5.151V12h11.849L37.5.151Z",
    style: {
      fill: "#d9d7ca",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c8bdb8"
    },
    d: "M20.706 45.569h20.027v1.515H20.706z",
    transform: "translate(-2.72 -2.284)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c8bdb8"
    },
    d: "M20.706 45.569h20.027v1.515H20.706z",
    transform: "translate(-2.72 .25)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c8bdb8"
    },
    d: "M20.706 45.569h20.027v1.515H20.706z",
    transform: "translate(-2.72 2.905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.74 23.186c-5.614 0-10.165 4.552-10.165 10.166 0 5.61 4.555 10.165 10.165 10.165 5.615 0 10.166-4.551 10.166-10.165H20.74V23.186Z",
    style: {
      fill: "#c8bdb8"
    },
    transform: "matrix(.91127 0 0 .91127 8.35 .052)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.906 33.352c0-5.614-4.551-10.166-10.166-10.166v10.166h10.166Z",
    style: {
      fill: "#c8bdb8"
    },
    transform: "matrix(.91127 0 0 .91127 9.85 -1.316)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff7853"
    },
    d: "M3.759 1.929h31.026v12.266H3.759z",
    transform: "matrix(1.04306 0 0 1.01149 -1.268 2.604)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.791 16.821H6.5v5.037l-3.709-5.037Z",
    style: {
      fill: "#f55d33"
    },
    transform: "translate(-.17 -.052) scale(1.01149)"
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fontFamily: "'ArialMT','Arial',sans-serif",
      fontSize: "9.336px",
      fill: "#fff"
    },
    transform: "translate(8.587 14.37) scale(1.08068)"
  }, "PPT"));
};
export default SvgSharePpt;